const lessonIssueI18n = {
  messageBody(t, body) {
    let tr;
    switch (body) {
      case 'Lesson was unscheduled':
        tr = t('chat.messages.lessonUnscheduled.title');
        break;
      case 'Issue was reported':
        tr = t('chat.messages.issueReported.title');
        break;
      case 'Issue was resolved':
        tr = t('chat.messages.issueResolved.title');
        break;
      default:
        tr = t('chat.messages.issueReportedAndResolved.title');
        break;
    }
    return tr;
  },

  type(t, type) {
    let tr;
    switch (type) {
      case 'Student was late':
        tr = t('issue.issueType.studentWasLate');
        break;
      case 'Student was absent':
        tr = t('issue.issueType.studentWasAbsent');
        break;
      case 'Student left early':
        tr = t('issue.issueType.studentLeftEarly');
        break;
      case 'Teacher was late':
        tr = t('issue.issueType.teacherWasLate');
        break;
      case 'Teacher was absent':
        tr = t('issue.issueType.teacherWasAbsent');
        break;
      case 'Teacher left early':
        tr = t('issue.issueType.teacherLeftEarly');
        break;
      case 'Student-related technical issue':
        tr = t('issue.issueType.studentTechIssue');
        break;
      case 'Teacher-related technical issue':
        tr = t('issue.issueType.teacherTechIssue');
        break;
      case 'LingualBox-related technical issue':
        tr = t('issue.issueType.lbTechIssue');
        break;
      case 'Other teacher-related issue':
        tr = t('issue.issueType.otherTeacherRelatedIssue');
        break;
      case 'Other student-related issue': // Should update later.
        tr = t('issue.issueType.otherStudentRelatedIssue');
        break;
      default:
        tr = t('issue.other');
    }
    return tr;
  },

  reason(t, reason) {
    let tr;
    switch (reason) {
      case 'Unstable internet connection':
        tr = t('issue.issueReason.unstableConnection');
        break;
      case 'Blackout':
        tr = t('issue.issueReason.blackout');
        break;
      case 'Computer problem':
        tr = t('issue.issueReason.computerProblem');
        break;
      case 'Sickness':
        tr = t('issue.issueReason.sickness');
        break;
      case 'Taking care of sick family member':
        tr = t('issue.issueReason.sicknessOfFamily');
        break;
      case 'Other tutor-side reason':
        tr = t('issue.issueReason.otherTutorSide');
        break;
      case 'Lesson was delivered':
        tr = t('issue.issueReason.lessonDelivered');
        break;
      case 'Cancel on behalf of student':
        tr = t('issue.issueReason.cancelOnBehalfOfStudent');
        break;
      default:
        tr = t('issue.other');
    }
    return tr;
  },

  action(t, action) {
    let tr;
    switch (action) {
      case 'Mark lesson as completed and issue 100% refund':
        tr = t('issue.resolveAction.fullRefund');
        break;
      case 'Mark lesson as completed and issue 50% refund':
        tr = t('issue.resolveAction.halfRefund');
        break;
      case 'Mark lesson as completed':
        tr = t('issue.resolveAction.markAsCompleted');
        break;
      default:
        tr = t('issue.resolveAction.markAsCancelled');
    }
    return tr;
  },
};

export default lessonIssueI18n;
